/** @jsxImportSource @emotion/react */
import { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';

import ToastContainer from './ToastContainer';
import { PropsType as ToastPropsType } from './Toast';

/**
 *
 * @param message string
 * @param options ToastPropsType
 * @descriptions
 * Toast는 createPortal을 이용해서 body의 하위 자식으로 추가되므로 실제로는 "#mrt-toast-root" div의 자식으로 추가되지 않습니다.
 * @example
 *
 * createToast('Hello Toast!');
 * createToast('Hello Toast!', {
 *   color: 'success',
 *   position: 'bottom',
 * });
 */
function createToast(message: ReactNode, options?: ToastPropsType) {
  const existMrtToastRootEl = document.getElementById('mrt-toast-root');
  let mrtToastRootEl: HTMLElement | null = existMrtToastRootEl;

  if (!mrtToastRootEl) {
    mrtToastRootEl = document.createElement('div');
    mrtToastRootEl.id = 'mrt-toast-root';
    document.body.appendChild(mrtToastRootEl);
  }

  const toastOption = {
    children: message,
    ...options,
  };

  const root = createRoot(mrtToastRootEl);
  root.render(<ToastContainer option={toastOption} />);
}

export default createToast;
